import {
  GridModalFormProps,
  UseFormReturnType,
  Validator,
  globalMessageHandler,
  useForm,
} from "common";
import { useParams } from "common/components/Form/ParamsContext";
import I18n from "i18n";
import { CouponItem, CouponOptions, getCouponService } from "./couponApi";

export interface UseCouponFormProps extends GridModalFormProps {}

export default function useCouponForm({
  id,
  afterSave,
  defaultValues,
}: UseCouponFormProps): UseFormReturnType<CouponItem, CouponOptions> & {
  params?: any;
} {
  const params = useParams<"coupon_id" | "partner_id">();
  const scope = { partners: params.partner_id };
  const service = getCouponService(scope);

  const form = useForm<CouponItem, CouponOptions>({
    id: params.coupon_id || id,
    ignoreNavigateAfterCreate: true,
    translationCategory: "Coupon",
    rules: {
      code: Validator.rule.string().required(),
      discount_percent: Validator.rule.number().required(),
    },
    afterSave,
    defaultValues: {
      active: true,
      discount_percent: 0,
      ...defaultValues,
    },
    onValidationFailed: () => {
      globalMessageHandler.snack({
        severity: "error",
        message: I18n.t("App.formHasErrors"),
      });
    },
    ...service,
    loadOptions: undefined,
  });

  return { ...form, params };
}
